import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { Props } from 'react-select';
import { Select as ChakraSelect } from 'chakra-react-select';
import { get } from 'lodash';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const Select = ({
  label,
  name,
  options = [],
  placeholder,
  ...rest
}) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const errorMessage = get(errors, name)?.message;

  return (
    <FormControl isInvalid={errorMessage}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <ChakraSelect
            inputRef={ref}
            placeholder={placeholder ?? ''}
            value={options.find((o) => value === o.value) ?? null}
            onChange={(o) => onChange(o.value)}
            options={options}
            inputId={name}
            {...rest}
          />
        )}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export default Select;
